module.exports = __webpack_public_path__ + "static/img/uav_blue.42e2e599.svg";